import styled from "styled-components";
import fipayFonts from "../../../../theme/index";
import { colors } from "../../../../theme/color";
import { feature3Img } from "../../../../../public/assets";

// Feature 1 textstyles

export const TitleHolder = styled.div`
  width: 417px;
  height: 112px;
  padding-top: 60px;
  padding-left: 30px;

  @media screen and (max-width: 768px) {
    width: 355px;
    height: 68px;
  }
  @media screen and (max-width: 430px) {
    width: 280px;
    height: 64px;
  }
  @media screen and (max-width: 375px) {
    width: 295px;
    height: 64px;
  }
`;

export const SubtitleHolder = styled.div`
  width: 534px;
  height: 64px;
  padding-left: 30px;

  @media screen and (max-width: 2560px) {
    width: 604;
  }

  @media screen and (max-width: 1024px) {
    width: 448px;
    height: 72px;
    margin-top: 80px;
  }
  @media screen and (max-width: 768px) {
    width: 448px;
    height: 72px;
    margin-top: 20px;
  }
  @media screen and (max-width: 430px) {
    width: 295px;
    height: 72px;
  }
  @media screen and (max-width: 375px) {
    width: 295px;
    height: 72px;
  }
  @media screen and (max-width: 320px) {
    width: 255px;
    height: 72px;
  }
`;

//contents of the small box

export const SmallTitle = styled.div`
  color: black;
  font-family: GT Walsheim Pro;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.36px;
  margin-bottom: 15px;
`;

export const ImageContainer = styled.img`
  width: 218px;
  height: 86px;
  object-fit: cover;
  /* background: url("/assets/icons/feature3Box.png");
  background-repeat: no-repeat;
  background-size: auto;
  background-position: center center; */

  @media screen and (max-width: 768px) {
    width: 181px;
    height: 68px;
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 375px) {
    width: 141px;
    height: 54px;
    /* flex-wrap: wrap; */
  }
`;

export const BigTitle = styled.div`
  color: black;
  font-family: GT Walsheim Pro;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 36px */
  margin-top: 30px;
`;

export const SubtitleFlexHolder = styled.div`
  width: 425px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* border: 2px solid red; */
  gap: 5px;
  margin-top: 15px;
  box-sizing: border-box;
  text-overflow: clip;

  @media screen and (max-width: 768px) {
    /* flex-direction: column; */
    width: 340px;
    height: 32px;
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 375px) {
    flex-direction: column;
    width: 171px;
    height: 40px;
    margin-top: 5px;
    /* flex-wrap: wrap; */
  }
`;

export const SmallSubtitle1 = styled.span`
  color: #5e5e5e;

  /* Web/Body/P1/Medium */
  font-family: GT Walsheim Pro;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0.36px;
  margin: 0;

  @media screen and (max-width: 375px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const SmallSubtitle2 = styled.span`
  color: ${colors.BLACK};

  /* Web/Body/P1/Medium */
  font-family: GT Walsheim Pro;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.36px;
  margin: 0;
  @media screen and (max-width: 375px) {
    font-size: 14px;
    line-height: 0;
  }
`;
